import { z } from 'zod';
import {
  strapiExperienceBaseSchema,
  strapiProjectBaseSchema,
  strapiSkillBaseSchema,
} from './base.js';

export const strapiProjectSchema = strapiProjectBaseSchema.extend({
  skills: z.array(strapiSkillBaseSchema).nullish(),
  experiences: z.array(strapiExperienceBaseSchema).nullish(),
});

export type StrapiProjectResponse = z.infer<typeof strapiProjectSchema>;
